var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module cercaliagl/service/GeometryEntity
 */
import Service from './Service';
/**
 * <b>Javascript ES5</b>
 * ```js
 * const geomEntService = new cercaliagl.service.GeometryEntity();
 * ```
 *
 * Geometry entity service can obtain geometry giving different geo entities. Actually available
 * entities are:
 * - Postal codes
 * - Municipalities
 * - Districts
 *
 * Example usage:
 *
 * ```js
 * const geomEntService = new cercaliagl.service.GeometryEntity();
 * geomEntService.getPostalCodeGeometry('ESP', '08001', (data) => {
 *   const feature = new cercaliagl.Feature({
 *     wkt: geomEntService.getWKT()
 *   });
 *   map.addFeature(feature);
 *   map.centerToFeatures([feature]);
 * });
 * ```
 *
 * @classdesc
 * @extends {Service}
 * @api
 */
var GeometryEntity = /** @class */ (function (_super) {
    __extends(GeometryEntity, _super);
    function GeometryEntity() {
        var _this = _super.call(this) || this;
        /**
         * @type {import('../servers').GeometryEntityResult|null}
         */
        _this.response_ = null;
        return _this;
    }
    /**
     * Get postal code geometry in WKT format.
     * @param {string} countryId Country Id.
     * @param {string} postalCode Postal code.
     * @param {Function} callbackFn Callback Function to parse data server response.
     * @api
     */
    GeometryEntity.prototype.getPostalCodeGeometry = function (countryId, postalCode, callbackFn) {
        var params = { cmd: 'geoment', countryId: countryId, postalCode: postalCode };
        this.getRequest({
            data: params,
            callbackFn: this.handleGeometryEntityResponse_.bind(this, callbackFn),
        });
    };
    /**
     * Get postal code geometry in WKT format.
     * @param {string} countryId Country Id.
     * @param {string} postalCode Postal code.
     * @param {Function} callbackFn Callback Function to parse data server response.
     * @api
     */
    GeometryEntity.prototype.getPostalCodeShortGeometry = function (pc2, callbackFn) {
        var params = { cmd: 'geoment', pc2: pc2 };
        this.getRequest({
            data: params,
            callbackFn: this.handleGeometryEntityResponse_.bind(this, callbackFn),
        });
    };
    /**
     * Get municipality geometry in WKT format.
     * @param {string} municipalityId Municipality.
     * @param {Function} callbackFn Callback function to parse data server response.
     * @api
     */
    GeometryEntity.prototype.getMunicipalityGeometry = function (municipalityId, callbackFn) {
        var params = { cmd: 'geoment', municipalityId: municipalityId };
        this.getRequest({
            data: params,
            callbackFn: this.handleGeometryEntityResponse_.bind(this, callbackFn),
        });
    };
    /**
     * Get district geometry in WKT format.
     * @param {string} districtId District id.
     * @param {Function} callbackFn Callback function to parse data server response.
     * @api
     */
    GeometryEntity.prototype.getDistrictGeometry = function (districtId, callbackFn) {
        var params = { cmd: 'geoment', districtId: districtId };
        this.getRequest({
            data: params,
            callbackFn: this.handleGeometryEntityResponse_.bind(this, callbackFn),
        });
    };
    /**
     * @private
     * @param {Function} callbackFn Callback functoin.
     * @param {import('../servers').GeometryEntityResult} data Server response
     */
    GeometryEntity.prototype.handleGeometryEntityResponse_ = function (callbackFn, data) {
        this.response_ = data;
        if (callbackFn) {
            callbackFn(data);
        }
    };
    /**
     * @api
     * @return {import('../servers').GeometryEntityResult|null} Response
     */
    GeometryEntity.prototype.getResponse = function () {
        return this.response_;
    };
    /**
     * @api
     * @return {string|null} WKT last geometry requested.
     */
    GeometryEntity.prototype.getWKT = function () {
        try {
            return this.response_.cercalia.ge.geometry.wkt.value;
        }
        catch (e) {
            return null;
        }
    };
    return GeometryEntity;
}(Service));
export default GeometryEntity;
//# sourceMappingURL=GeometryEntity.js.map